// ADIRATH — Gallery page: filterable masonry + lightbox.
import React from 'react';
import { IMG } from './images';
import { PageHero } from './serviceData';
import { Icon } from './Icon';
import { CTASection } from './HomeSectionsB';

// Only encode spaces — leave +, (, ) and other valid filename chars untouched
const G = (path) => '/gallery/' + path.replace(/ /g, '%20');

const ITEMS = [
  // ── BESS ─────────────────────────────────────────────────────────────
  { src: G('Bess/ADIRATH-BESS.webp'),                    cat: 'BESS', caption: 'ADIRATH BESS System' },
  { src: G('Bess/ADIRATH-BESS_1.webp'),                  cat: 'BESS', caption: 'ADIRATH BESS — Front View' },
  { src: G('Bess/ADIRATH-BESS_2.webp'),                  cat: 'BESS', caption: 'ADIRATH BESS — Side View' },
  { src: G('Bess/1MW BESS.webp'),                         cat: 'BESS', caption: '1MW BESS System' },
  { src: G('Bess/5MW BESS4.webp'),                        cat: 'BESS', caption: '5MW BESS System' },
  { src: G('Bess/5MW BESS5.webp'),                        cat: 'BESS', caption: '5MW BESS — Installation' },
  { src: G('Bess/bESS1.webp'),                            cat: 'BESS', caption: 'BESS Unit' },
  { src: G('Bess/200Ah.webp'),                            cat: 'BESS', caption: '200Ah BESS' },
  { src: G('Bess/240V_1.webp'),                           cat: 'BESS', caption: '240V BESS Unit' },
  { src: G('Bess/240V_2.webp'),                           cat: 'BESS', caption: '240V BESS Unit' },
  { src: G('Bess/240V_3.webp'),                           cat: 'BESS', caption: '240V BESS Unit' },
  { src: G('Bess/240V_4.webp'),                           cat: 'BESS', caption: '240V BESS Unit' },
  { src: G('Bess/240V_5.webp'),                           cat: 'BESS', caption: '240V BESS Unit' },
  { src: G('Bess/5kW_Parallel_ Module_1.webp'),           cat: 'BESS', caption: '5kW Parallel Module' },
  { src: G('Bess/5kW_Parallel_ Module_2.webp'),           cat: 'BESS', caption: '5kW Parallel Module' },
  { src: G('Bess/5kW_Parallel_ Module_3.webp'),           cat: 'BESS', caption: '5kW Parallel Module' },
  { src: G('Bess/Datasheet_BESS-125kW+261kWh-5.webp'),    cat: 'BESS', caption: '125kW + 261kWh BESS' },
  { src: G('Bess/Agnikul_1.webp'),                        cat: 'BESS', caption: 'Agnikul — BESS Project' },
  { src: G('Bess/Hachidori_1.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },
  { src: G('Bess/Hachidori_2.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },
  { src: G('Bess/Hachidori_3.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },
  { src: G('Bess/Hachidori_4.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },
  { src: G('Bess/Hachidori_5.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },
  { src: G('Bess/Hachidori_6.webp'),                      cat: 'BESS', caption: 'Hachidori — BESS' },

  // ── Industrial Mobility ──────────────────────────────────────────────
  { src: G('Industrial Mobility Batteries/48V 100Ah Pouch.webp'), cat: 'Industrial Mobility', caption: '48V 100Ah Pouch Cell' },
  { src: G('Industrial Mobility Batteries/Pic 1 with Tester.webp'), cat: 'Industrial Mobility', caption: 'Battery with Tester' },
  { src: G('Industrial Mobility Batteries/3.webp'),              cat: 'Industrial Mobility', caption: 'Industrial Mobility Battery' },
  { src: G('12V100Ah_1.webp'),                                   cat: 'Industrial Mobility', caption: '12V 100Ah Battery Pack' },
  { src: G('12V100Ah_2.webp'),                                   cat: 'Industrial Mobility', caption: '12V 100Ah Battery Pack' },
  { src: G('12V100Ah_3.webp'),                                   cat: 'Industrial Mobility', caption: '12V 100Ah Battery Pack' },
  { src: G('12V_100Ah_WB.webp'),                                 cat: 'Industrial Mobility', caption: '12V 100Ah WB Pack' },
];

const CATS = ['All', 'BESS', 'Industrial Mobility'];

export function GalleryPage({ onNavigate }) {
  const [filter, setFilter] = React.useState('All');
  const [light, setLight] = React.useState(null);
  const shown = filter === 'All' ? ITEMS : ITEMS.filter((it) => it.cat === filter);

  React.useEffect(() => {
    const onKey = (e) => {
      if (light === null) return;
      if (e.key === 'Escape') setLight(null);
      if (e.key === 'ArrowRight') setLight((l) => (l + 1) % shown.length);
      if (e.key === 'ArrowLeft')  setLight((l) => (l - 1 + shown.length) % shown.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [light, shown.length]);

  return (
    <div>
      <PageHero kicker="Gallery" crumbs={['Gallery']} onNavigate={onNavigate} image="bess"
        title="Inside ADIRATH — batteries, BESS & field projects."
        sub="A look at our products and deployments across industries." />

      <section style={{ padding: 'var(--section-y) 0', background: 'var(--surface-page)' }}>
        <div style={{ maxWidth: 'var(--container-xl)', margin: '0 auto', padding: '0 var(--gutter)' }}>

          {/* Filter tabs */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 36 }}>
            {CATS.map((c) => {
              const active = filter === c;
              return (
                <button key={c} onClick={() => { setFilter(c); setLight(null); }} style={{
                  padding: '9px 18px', borderRadius: 'var(--radius-pill)', cursor: 'pointer',
                  border: active ? '1.5px solid var(--accent)' : '1.5px solid var(--border-strong)',
                  background: active ? 'var(--accent)' : 'var(--surface-card)',
                  color: active ? '#fff' : 'var(--text-body)',
                  fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 14,
                  transition: 'all var(--dur-fast)',
                }}>{c}</button>
              );
            })}
          </div>

          {/* Masonry grid */}
          <div className="adr-masonry" style={{ columnCount: 3, columnGap: 18 }}>
            {shown.map((it, i) => (
              <div key={it.src} className="adr-masonry-item" onClick={() => setLight(i)} style={{
                breakInside: 'avoid', marginBottom: 18, borderRadius: 'var(--radius-lg)',
                overflow: 'hidden', position: 'relative', cursor: 'pointer', boxShadow: 'var(--shadow-sm)',
              }}>
                <img src={it.src} alt={it.caption} loading="lazy" style={{ width: '100%', display: 'block', transition: 'transform var(--dur-slow) var(--ease-out)' }} />
                <div className="adr-gallery-cap" style={{
                  position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
                  justifyContent: 'flex-end', padding: 16,
                  background: 'linear-gradient(180deg, transparent 40%, rgba(8,27,51,0.82))',
                  opacity: 0, transition: 'opacity var(--dur-fast)',
                }}>
                  <span style={{ fontFamily: 'var(--font-ui)', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--energy-bright)' }}>{it.cat}</span>
                  <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, color: '#fff', fontSize: 15 }}>{it.caption}</span>
                  <span style={{ position: 'absolute', top: 14, right: 14, width: 36, height: 36, borderRadius: '50%', background: 'var(--glass-dark-bg)', border: '1px solid var(--glass-dark-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                    <Icon name="maximize-2" style={{ width: 16, height: 16 }} />
                  </span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Lightbox */}
      {light !== null && shown[light] && (
        <div onClick={() => setLight(null)} style={{ position: 'fixed', inset: 0, zIndex: 100, background: 'rgba(5,15,31,0.92)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--gutter)' }}>
          <button aria-label="Close" onClick={() => setLight(null)} style={lbBtn({ top: 22, right: 22 })}><Icon name="x" style={{ width: 24, height: 24 }} /></button>
          <button aria-label="Previous" onClick={(e) => { e.stopPropagation(); setLight((l) => (l - 1 + shown.length) % shown.length); }} style={lbBtn({ left: 22 })}><Icon name="chevron-left" style={{ width: 26, height: 26 }} /></button>
          <button aria-label="Next" onClick={(e) => { e.stopPropagation(); setLight((l) => (l + 1) % shown.length); }} style={lbBtn({ right: 22 })}><Icon name="chevron-right" style={{ width: 26, height: 26 }} /></button>
          <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: 1000, width: '100%' }}>
            <img src={shown[light].src} alt={shown[light].caption} style={{ width: '100%', borderRadius: 'var(--radius-lg)', display: 'block', boxShadow: 'var(--shadow-xl)', maxHeight: '75vh', objectFit: 'contain' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, color: '#fff' }}>
              <div>
                <div style={{ fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--energy-bright)' }}>{shown[light].cat}</div>
                <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 18 }}>{shown[light].caption}</div>
              </div>
              <div style={{ fontFamily: 'var(--font-mono)', color: 'rgba(255,255,255,0.6)' }}>{String(light + 1).padStart(2, '0')} / {String(shown.length).padStart(2, '0')}</div>
            </div>
          </div>
        </div>
      )}

      <CTASection onNavigate={onNavigate} />
    </div>
  );
}

export function lbBtn(pos) {
  return Object.assign({ position: 'fixed', top: pos.top || '50%', transform: pos.top ? 'none' : 'translateY(-50%)', zIndex: 101, width: 50, height: 50, borderRadius: '50%', border: '1px solid var(--glass-dark-border)', background: 'var(--glass-dark-bg)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }, pos);
}
